import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import BetaNotification from "./BetaNotification";
import * as serviceWorker from "./serviceWorker";
import "react-datepicker/dist/react-datepicker.css";
import "react-tempusdominus-bootstrap";

ReactDOM.render(
  <React.StrictMode>
    <BetaNotification />
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
